<script>
  import { onMount } from "svelte";
  import QrCode from "svelte-qrcode";
  import { projectListStore } from "@stores/damProjectsStore.js";
  import { useUrlParams } from "@stores/urlStore.js";
  import { fly } from "svelte/transition";
  import {
    DataTable,
    Toolbar,
    ToolbarContent,
    Link,
    ToolbarSearch,
    CodeSnippet,
    Modal as DangerModal
} from "carbon-components-svelte";
  import {
  Pagination,
    TextInput,
    TextArea,
    SectionWrapper,
    Button,
    Select,
    SelectItem,
  } from "paxray-components-svelte";
  //    import { ContentSwitcher, Switch } from "carbon-components-svelte";
  //    import { InlineLoading } from "carbon-components-svelte";
  //    import download from "downloadjs"
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import MultiSelect from "lib/components/MultiSelect.svelte";

  import LimitationList from "../components/LimitationList.svelte";
  import Modal from "../../../../lib/components/Modal.svelte";
  import { formatISOTimestamp } from "../../../../lib/util/formatfunctions";
  import { EDIT_ICON, TRASH_ICON } from "@utils/icons.js";

  export let isCompleted = false;

  const { updateProjectStep } = projectListStore;
  const urlParams = useUrlParams();

  let baseurl = "";
  let installerGenerated = isCompleted;
  let currentTeam = { damUsers: [], subprocesses: [] };
  let teams = [];
  let teamModalOpen = false;
  let idLimitation = 0;
  let limitationPresets = [];
  let selectedPresetIds = [];
  let users = [];
  let subprocesses = [];
  let presetPage = 1;
  let presetPageSize = 10;
  let qrModalOpen = false;
  let message = "";

  let openDangerModal;
  let selectedOption = "all";
  let selectedDomain = "all";
  let listOfDomains = [];

  $: ({ idproject, currentStep } = $urlParams);

  $: if (idproject) {
    loadProjectData();
  }

  $: {
    baseurl =
      window.location.protocol +
      "//" +
      window.location.host +
      (window.location.port ? ":" + window.location.port : "");
  }

  $: filteredUsers = users.filter((user) => {
    let passesAssignmentFilter = true;
    if (selectedOption === "assigned") {
      passesAssignmentFilter = user.assigned !== "";
    } else if (selectedOption === "unassigned") {
      passesAssignmentFilter = user.assigned === "";
    }

    //Filter by domain
    let passesDomainFilter = true;
    if (selectedDomain !== "all") {
      passesDomainFilter = user.domain === selectedDomain;
    }

    return passesAssignmentFilter && passesDomainFilter;
  });

  function editTeam(id) {
    if (id != 0) {
      currentTeam = { ...teams.find((x) => x.id == id) };
    } else {
      currentTeam = {
        id: 0,
        typeIndex: 0,
        damUsers: [],
        subprocesses: [],
      };
    }
    selectedOption = "all";
    selectedDomain = "all";
    teamModalOpen = true;
  }

  function saveTeam() {
    let method = "POST";
    const teamToSave = {
      name: currentTeam.name,
      idproject: idproject,
      damUsers: currentTeam.damUsers,
      subprocesses: currentTeam.subprocesses,
    };

    if (currentTeam.id) {
      method = "PATCH";
      teamToSave.id = currentTeam.id;
    }

    fetchWithSession(
      `/api/damprojects/dam-teams${currentTeam.id ? "/" + currentTeam.id : ""}`,
      {
        method: method,
        body: JSON.stringify(teamToSave),
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.ok) {
          if (data.data.id != currentTeam.id) {
            currentTeam.id = data.data.id;
            teams.push(currentTeam);
            teams = teams;
          } else {
            teams[teams.findIndex((x) => x.id == currentTeam.id)] = currentTeam;
          }
          updateUserAssignments();
        }

        teamModalOpen = false;
      })
      .catch((err) => {
        teamModalOpen = false;
      });
  }

  function deleteTeam() {
    fetchWithSession(`/api/damprojects/dam-teams/${currentTeam.id}`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.ok) {
          teams = teams.filter((x) => x.id != currentTeam.id);
          updateUserAssignments();
        }
      });

    openDangerModal = false;
  }

  function startRecording() {
    fetchWithSession(`/api/damprojects/startScopingRecording`, {
      method: "POST",
      body: JSON.stringify({
        idproject: idproject,
        selectedPresetIds: selectedPresetIds,
        message: message,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        fetchWithSession(
          `/api/damprojects/completeDAMProjectStep/${idproject}/0`,
          {
            method: "POST",
          },
        )
          .then((res) => res.json())
          .then((data) => {
            if (data.success) {
              isCompleted = true;
            }
            currentStep += 1;
            updateProjectStep(idproject, currentStep);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async function handleLastUpdateClick(row) {
    try {
      const response = await fetchWithSession(`/api/settings/apikey`);
      const data = await response.json();
      const apiKey = data.apikey;
      window.open(
        `/data/getConfig?key=${apiKey}&username=${row.fullname}&version=0&checkuser=true`,
        "_blank",
      );
    } catch (err) {
      console.error("Error getting apikey:", err);
    }
  }

  async function getDamTeams() {
    return fetchWithSession(
      `/api/damprojects/dam-teams?idproject=${idproject}`,
      {
        method: "GET",
      },
    )
      .then((res) => res.json())
      .then((data) => {
        teams = data.map((team) => ({
          ...team,
          damUsers: team.damUsers.map((user) => user.id),
          subprocesses: team.subprocesses.map((subprocess) => subprocess.id),
        }));
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function getSubprocesses() {
    fetchWithSession(`/api/damprojects/subprocesses`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        subprocesses = data;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function updateUserAssignments() {
    users = users
      .map((user) => {
        const assignedTeams = teams
          .filter((team) => team.damUsers.includes(user.id))
          .map((team) => team.name);

        return {
          ...user,
          assigned: assignedTeams.join(", ") || "",
        };
      })
      .sort((a, b) => {
        if (!a.assigned && !b.assigned) return 0;
        if (!a.assigned) return 1;
        if (!b.assigned) return -1;
        return a.assigned.localeCompare(b.assigned);
      });
  }

  async function loadProjectData() {
    await getDamTeams();
    getSubprocesses();

    fetchWithSession(`/api/damprojects/getProjectLimitations/${idproject}/0`)
      .then((res) => res.json())
      .then((data) => (idLimitation = data));
    loadUsers();
  }

  function loadUsers() {
    fetchWithSession(`/api/damprojects/getDAMTeamUsers`)
      .then((res) => res.json())
      .then((data) => {
        const dataTimeFormated = data.map((item) => ({
          ...item,
          lastupdate: formatISOTimestamp(item.lastupdate.slice(0, -6)),
        }));
        const tempDomains = [];
        users = dataTimeFormated
          .map((user, index) => {
            const [domain, ...nameParts] = user.name.split("\\");
            const name = nameParts.join("\\").replace(/^\\+/, "");
            tempDomains.push(domain);
            const assignedTeam = teams
              .filter((team) => team.damUsers.includes(user.id))
              .map((team) => team.name);
            return {
              ...user,
              domain: domain,
              name: name,
              assigned: assignedTeam.join(", ") || "",
              fullname: user.name,
            };
          })
          .sort((a, b) => {
            if (!a.assigned && !b.assigned) return 0;
            if (!a.assigned) return 1;
            if (!b.assigned) return -1;
            return a.assigned.localeCompare(b.assigned);
          });
        listOfDomains = [...new Set(tempDomains)];
      })
      .catch((err) => {
        console.error(err);
      });
  }

  onMount(() => {
    fetchWithSession(`/api/damprojects/limitation-presets`)
      .then((response) => response.json())
      .then((data) => {
        limitationPresets = data;
      });
  });

  $$restProps;
</script>

<SectionWrapper fullscreen={true}>
  <div class="main" slot="main">
    <div class="table_heading info_wrapper">
      <h5>Project Setup</h5>
      <div class="info">
        Define the scope of your analysis project. This is the first step of the
        analysis process. Set between how many teams you want to differentiate
        and set a blacklist or whitelist for the recorded applications for the
        first scoping.
      </div>
    </div>

    <div class="table_heading">
      <h5>Team Settings</h5>
      <div>Manage the Users and/or Teams</div>
    </div>
    <DataTable
      size="short"
      headers={[
        { key: "name", value: "Name" },
        { key: "users", value: "Assigned users" },
        { key: "menu", empty: true, width: "101px" },
      ]}
      rows={teams || []}
      sortable
    >
      {#if !installerGenerated}
        <Toolbar>
          <ToolbarContent>
            <Button
              text="Add Team"
              kind="secondary"
              on:click={() => {
                editTeam(0);
              }}
            />
          </ToolbarContent>
        </Toolbar>
      {/if}
      <svelte:fragment slot="cell" let:cell let:row>
        {#if cell.key === "menu"}
          <Button
            size="small"
            kind="secondary"
            icon={EDIT_ICON}
            on:click={editTeam(row.id)}
            iconDescription="Edit"
          />
          {#if !installerGenerated}
            <Button
              size="small"
              kind="danger"
              icon={TRASH_ICON}
              on:click={() => {
                currentTeam = row;
                openDangerModal = true;
              }}
              iconDescription="Delete"
            />
          {/if}
        {:else if cell.key === "users"}
          {row.damUsers.length}
        {:else}
          {cell.value}
        {/if}
      </svelte:fragment>
    </DataTable>

    <div class="table_heading">
      <h5>Limitation Presets</h5>
      <div>Create and Edit preset Whitelists and Blacklists.</div>
    </div>
    <DataTable
      headers={[
        { key: "name", value: "Name" },
        { key: "type", value: "Type" },
      ]}
      rows={limitationPresets || []}
      sortable
      batchSelection
      bind:selectedRowIds={selectedPresetIds}
      page={presetPage}
      pageSize={presetPageSize}
    >
      <Toolbar>
        <ToolbarContent>
          <ToolbarSearch />
        </ToolbarContent>
      </Toolbar>
      <span slot="cell" let:row let:cell>
        <Link href="/app/dam/presets/limitation?idLimitation={row.id}"
          >{cell.value}</Link
        >
      </span>
    </DataTable>
    <Pagination
      dark
      bind:pageSize={presetPageSize}
      bind:page={presetPage}
      totalItems={limitationPresets.length}
      pageSizes={[10, 25, 50]}
    />

    <div class="table_heading">
      <h5>Limitations</h5>
      <div>Create your project-specific Limitations</div>
    </div>

    <div>
      If you want to get iser input for the limitations, you can access the
      workshop view for this project at: <br /><br />
      <table>
        <tr>
          <td style="vertical-align:top">
            <CodeSnippet code={baseurl + "/UserInput?idproject=" + idproject}
            ></CodeSnippet>
          </td><td>
            <Button
              size="field"
              kind="outline"
              on:click={() => {
                qrModalOpen = true;
              }}
              text="Show QR Code"
            />
          </td>
        </tr>
      </table>
    </div>

    <LimitationList editable={!installerGenerated} />

    <TextArea
      labelText="Message"
      placeholder="Enter a message for the users"
      bind:value={message}
    />

    {#if !isCompleted}
      <div class="button_wrapper">
        <Button
          text="Start Recording"
          kind="secondary"
          on:click={startRecording}
        />
      </div>
    {/if}
  </div>
</SectionWrapper>

<Modal
  autowidth
  bind:open={qrModalOpen}
  preventCloseOnClickOutside
  actions
  modalHeading="Workshop QR Code"
  primaryButtonText="Ok"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    qrModalOpen = false;
  }}
  primaryButtonAction={() => {
    qrModalOpen = false;
  }}
  on:close={() => {
    qrModalOpen = false;
  }}
>
  <div style="margin:0 auto; width:300px;">
    <QrCode value={baseurl + "/UserInput?idproject=" + idproject} />
    <h4>{baseurl + "/UserInput?idproject=" + idproject}</h4>
  </div>
</Modal>

<div Class="scoping-team-modal">
  <Modal
    autowidth
    preventCloseOnClickOutside
    bind:open={teamModalOpen}
    modalHeading="Team {currentTeam.name || ''}"
    on:open
    on:close={() => {
      teamModalOpen = false;
    }}
  >
    <div class="new_team_modal_wrapper">
      {#if !currentTeam.id}
        <TextInput
          labelText="Name"
          placeholder="Enter Team Name"
          bind:value={currentTeam.name}
          readonly={installerGenerated}
          invalid={!currentTeam.name}
          invalidText="Please insert a name for the team"
        />
      {/if}

      <MultiSelect
        labelText="Subprocesses"
        label="Select subprocesses ..."
        items={subprocesses.map((subprocess) => ({
          id: subprocess.id,
          text: subprocess.name,
        }))}
        bind:selectedIds={currentTeam.subprocesses}
      ></MultiSelect>

      <div class="select_wrapper">
        <Select noLabel inline bind:selected={selectedOption}>
          <SelectItem value="all" text="Show all" />
          <SelectItem value="assigned" text="Show assigned users" />
          <SelectItem value="unassigned" text="Show unassigned users" />
        </Select>

        <Select noLabel inline bind:selected={selectedDomain}>
          <SelectItem value="all" text="All domains" />
          {#each listOfDomains as domain}
            <SelectItem value={domain} text={domain} />
          {/each}
        </Select>
      </div>
      <DataTable
        size="short"
        headers={[
          { key: "name", value: "Name" },
          { key: "domain", value: "Domain" },
          { key: "lastupdate", value: "Last Updated" },
          { key: "assigned", value: "Assigned team" },
        ]}
        rows={filteredUsers || []}
        bind:selectedRowIds={currentTeam.damUsers}
        sortable
        selectable
        batchSelection
      >
        <Toolbar>
          <ToolbarContent>
            <ToolbarSearch persistent shouldFilterRows />
          </ToolbarContent>
        </Toolbar>
        <svelte:fragment slot="cell" let:cell let:row>
          {#if cell.key === "lastupdate"}
            <button
              type="button"
              style="border: none; background: none; padding: 0; cursor: pointer; color: inherit; font: inherit; text-decoration: underline;"
              on:click={() => handleLastUpdateClick(row)}
            >
              {cell.value}
            </button>
          {:else}
            {cell.value}
          {/if}
        </svelte:fragment>
      </DataTable>
    </div>
    <div class="team-modal-divider divider-margin" />
    <div class="actions-buttons-container">
      <Button
        kind="secondary"
        text="Cancel"
        on:click={() => {
          teamModalOpen = false;
        }}
      />
      <div class="primary-buttons">
        <Button
          kind="secondary"
          text="Help"
          on:click={() => {
            // Handle Help button click
            window.open("/app/dam/installationInstructions", "_blank");
          }}
        />
        <Button
          text="Save"
          disabled={!currentTeam.name}
          on:click={() => {
            if (currentTeam.name) saveTeam();
          }}
        />
      </div>
    </div>
  </Modal>
</div>

<DangerModal
  danger
  bind:open={openDangerModal}
  preventCloseOnClickOutside
  modalHeading="Delete"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  on:click:button--primary={deleteTeam}
  on:click:button--secondary={() => (openDangerModal = false)}
>
  <p class="deleteModalBody">
    Are you sure you want to delete this team:
    <span class="team-name">{currentTeam?.name}</span>?
    <span>This action cannot be undone.</span>
  </p>
</DangerModal>

<style>
  .main {
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .table_heading {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #fc8b5d;
    color: var(--pax-white);
    border-left: 0.6rem solid var(--pax-orange);
    padding: 0.6rem 1rem;
    border-radius: 0.5rem;
  }

  .info_wrapper {
    background: var(--pax-black);
    color: white;
    border-left: 0;
  }

  .button_wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .new_team_modal_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .team-name {
    font-weight: bold;
  }

  .select_wrapper {
    display: flex;
    gap: 1rem;
    justify-items: start;
    width: fit-content;
  }

  .team-modal-divider {
    width: 100%;
    height: 1px;
    background: #d9d9d9;
    margin-bottom: 1rem;
  }

  .divider-margin {
    margin-top: 1rem;
  }

  .actions-buttons-container {
    display: flex;
    justify-content: space-between;
  }

  .actions-buttons-container .primary-buttons {
    display: flex;
    gap: 0.5rem;
  }

  :global(.scoping-team-modal .modal_wrapper .divider),
  :global(.scoping-team-modal .actions-buttons-container) {
    display: none;
  }
</style>
